import { render } from "./ImportData.vue?vue&type=template&id=bdd73870"
import script from "./ImportData.vue?vue&type=script&lang=js"
export * from "./ImportData.vue?vue&type=script&lang=js"

import exportComponent from "D:\\ProjektetRentaCar\\rentaxerxe\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QUploader from 'quasar/src/components/uploader/QUploader.js';
import qInstall from "../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QDialog,QCard,QUploader});
